class r {
  succeeded;
  statusDescription;
  status;
  errors;
  result;
  constructor(s) {
    this.succeeded = s.succeeded, this.status = s.status, this.statusDescription = s.statusDescription ?? "", this.errors = s.errors ?? [], this.result = s.result;
  }
}
export {
  r as UserAccountOperationResult
};
//# sourceMappingURL=index.js.map
